/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import SelectPlans from 'components/atoms/select_plans';
import Planos from 'components/organisms/planos';
import { getTheLastSale } from 'services/actions/get_the_last_sale';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { PackagesResponse, SimulateTypes } from 'store/modules/simulate_all_store/types';
import { MyAccountTypes } from 'store/modules/my_account_store/types';
import Loader from 'components/atoms/loader';

const PlansList: React.FC = () => {
  const dispatch = useDispatch();
  const [viewPage, setViewPage] = useState<string>('inicio');
  const [plansData, setPlansData] = useState<PackagesResponse | null>(null);
  const [planCheckoutData, setPlanCheckoutData] = useState<object | null>(null);

  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  useEffect(() => {
    const initializePage = async () => {
      document.title = 'Planos e Preços - ConLicitação';
      const lastSaleData = await getTheLastSale();

      if (lastSaleData) {
        dispatch({
          type: SimulateTypes.STATE_CARD_PAYMENT,
          payment: lastSaleData.card_payment,
        });

        setViewPage(lastSaleData.layout);
        setPlanCheckoutData(lastSaleData);
        setPlansData(lastSaleData.packages);
      }
    };

    initializePage();
  }, [dispatch]);

  const handleRedirects = () => {
    if (panel?.renewal_campaign?.released_online) return '/renovacao';
    if (!panel?.validate_services?.course_iaml && panel?.registration_type_validation === 1)
      return '/cadastrar';
    if (viewPage === 'contact_screen') return '/contato';
    if (viewPage === 'all_packages') setViewPage('');

    if (viewPage === 'income_online') {
      dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'boletos_online' });
      window.location.href = '/minha_conta/boletos_online';
    }
    if (!viewPage) return '/contato';
  };

  const redirectPath = handleRedirects();
  if (redirectPath) return <Redirect to={redirectPath} />;

  if (viewPage === 'inicio') {
    return (
      <div
        className="d-flex mx-auto justify-content-center align-items-center"
        style={{ height: '70vh' }}
      >
        <Loader />
      </div>
    );
  }

  const renderContent = () => {
    if (viewPage === 'checkout') {
      return <Planos viewPage={viewPage} dadosPlanCheckout={planCheckoutData} />;
    }

    if (!plansData) {
      return (
        <div
          className="d-flex mx-auto justify-content-center align-items-center"
          style={{ height: '50vh' }}
        >
          <Loader />
        </div>
      );
    }

    return <SelectPlans packages={plansData} />;
  };

  return (
    <div className="page-container">
      <div className="container">
        <div className="row">
          <div className="col-12">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default PlansList;
